<div class="row">
	<div class="col-sm-6">
		<h3>{{t "push.editPush"}}</h3>
	</div>
	<div class="col-sm-6 actions-col">
		<a href="javascript:history.go(-1)"><button class="button white">{{t "common.back"}}</button></a>
		<button class="button green save-button">{{t "common.save"}}</button>
	</div>
</div>
